import { render, staticRenderFns } from "./FormCollaborative.vue?vue&type=template&id=7d4de246&scoped=true&"
import script from "./FormCollaborative.vue?vue&type=script&lang=js&"
export * from "./FormCollaborative.vue?vue&type=script&lang=js&"
import style0 from "./FormCollaborative.vue?vue&type=style&index=0&id=7d4de246&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d4de246",
  null
  
)

export default component.exports